import services from '../services'
import * as types from './mutation-types'

export const getAll = ({ commit }, params) => (
  services.list(params).then(res => {
    commit(types.SET_HOTEL_ACCOMMODATIONS, res.data)
  })
)

export const getTypeAccomodations = ({ commit }, params) => (
  services.typesAccommodations(params).then(res => {
    return res.data
  })
)

export const getAccommodation = async ({ commit }, id) => {
  await services.show(id).then(res => {
    commit(types.SET_HOTEL_ACCOMMODATION, res.data.data)
  })
}

export const save = async ({ commit }, obj) => {
  await services.saveAccommodation(obj).then(res => {
    commit(types.SET_HOTEL_ACCOMMODATION, res.data.data)
    return res
  })
}

export const deleteAccommodation = async ({ commit }, id) => {
  await services.delAccommodation(id).then(res => {
    return res
  })
}
